import React from "react";
import { FaRegFileAudio } from "react-icons/fa6";
import { App, Upload } from "antd";
import { useDispatch } from "react-redux";
import {
  previewStep,
  setBailiffDocumentUploadComplete,
} from "store/bailiff/bailiff/document/bailiff_document.action";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
const ALLOW_FORMAT = [
  "video/mp4",
  "video/quicktime",
  "audio/mp4",
  "audio/x-m4a",
  "audio/3gpp",
  "audio/aac",
  "audio/amr",
  "audio/ogg",
  "audio/opus",
  "audio/mpeg",
];

const { Dragger } = Upload;

const DraggerAudio = ({
  name = "file",
  title = "Nhấn hoặc kéo thả file vào khu vực này để tải lên",
  subTitle = `Chỉ hỗ trợ upload từng file. Không tải lên tài nguyên độc hại hoặc bị cấm trong điều khoản chung. Hỗ trợ các định dạng (${ALLOW_FORMAT?.join(
    ", ",
  )}) \n (Tải lên tối đa 512MB)`,
  onUpload = () => {},
  multiple = false,
}) => {
  // -------------------------- VAR -----------------------------
  const { message } = App?.useApp();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION ------------------------
  const beforeUpload = (file) => {
    console.log({ type: file.type });
    const isJpgOrPng = handleValidFormat(file?.type);
    if (!isJpgOrPng) {
      message.error(
        `Bạn chỉ được phép tải lên Audio/Video File trong những định dạng sau ${ALLOW_FORMAT?.join(
          ", ",
        )}`,
      );
    }
    const isLt2M = file.size / 1024 / 1024 < 512;
    if (!isLt2M) {
      message.error("Video/Audio phải nhỏ hơn 512MB!");
    }
    return isJpgOrPng && isLt2M;
  };

  const onDrop = (e) => {
    console.log("Dropped files", e.dataTransfer.files);
  };

  const onChange = (info) => {
    const { status } = info.file;
    if (status === "uploading") {
    }

    if (status === "done") {
      message.success(`${info.file.name} tải lên thành công!`);
    }
    if (status === "error") {
      message.error(`${info.file.name} tải lên thất bại.`);
    }

    console.log({ status });
  };

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Dragger
      name={name}
      multiple={multiple}
      maxCount={1}
      onDrop={onDrop}
      showUploadList={false}
      customRequest={onUpload}
      onChange={onChange}
      beforeUpload={beforeUpload}
      accept="audio/*, video/*"
    >
      <p className="ant-upload-drag-icon flex min-h-[200px] flex-col items-center justify-center gap-[8px]">
        <FaRegFileAudio className="mb-[16px]" size={80} color="#aeaeae" />
        <p className="ant-upload-text font-bold !text-gray-500">{title}</p>
        <p className="ant-upload-hint">{subTitle}</p>
      </p>
    </Dragger>
  );
};
export default DraggerAudio;

const handleValidFormat = (type) => {
  const exist = ALLOW_FORMAT?.filter((a) => {
    const valid = String(type)?.includes(a);
    return valid;
  });

  const isExist = exist?.length > 0;
  return isExist;
};
